module.exports = __webpack_public_path__ + "img/notificationspleno.09d67a18.svg";